<template>
<div class="chapter">
<div class="inner_page">
<h1 class="ch-title"><a id="page_5">List of Illustrations</a></h1><a id="page_5">
</a><p class="fnoindent1"><a id="page_5"></a><a href="#/xhtml/05_Fm02#fig1">The Crown of Victory</a></p>
<p class="fnoindent1"><a href="#/xhtml/09_Chapter01#fig2">A Riverside Encampment</a></p>
<p class="fnoindent1"><span href="#/xhtml/12_Chapter04#fig3" title="Link target outside of Sample">Hadon Before Minruth</span></p>
<p class="fnoindent1"><span href="#/xhtml/12_Chapter04#fig4" title="Link target outside of Sample">The Leopards!</span></p>
<p class="fnoindent1"><span href="#/xhtml/17_Chapter09#fig5" title="Link target outside of Sample">The Klemquaba Contingent</span></p>
<p class="fnoindent1"><span href="#/xhtml/18_Chapter10#fig6" title="Link target outside of Sample">Kwasin Slays a Chief!</span></p>
<p class="fnoindent1"><span href="#/xhtml/20_Chapter12#fig7" title="Link target outside of Sample">The Meeting with Lalila</span></p>
<p class="fnoindent1"><span href="#/xhtml/23_Chapter15#fig8" title="Link target outside of Sample">Kwasin Exiled</span></p>
<p class="fnoindent1"><span href="#/xhtml/25_Chapter17#fig9" title="Link target outside of Sample">Return of the Galley</span></p>
<p class="fnoindent1"><span href="#/xhtml/28_Chapter20#fig10" title="Link target outside of Sample">In Awineth’s Cell</span></p>
<p class="fnoindent1t"><span href="#/xhtml/30_Map#map1" title="Link target outside of Sample">Map 1—Ancient Africa</span></p>
<p class="fnoindent1"><span href="#/xhtml/30_Map#map2" title="Link target outside of Sample">Map 2—Kemu</span></p>
<p class="fnoindent1"><span href="#/xhtml/30_Map#map3" title="Link target outside of Sample">Map 3—Khokarsa</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_listofillustration.vue?45125b31